/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { IconGroup } from 'semantic-ui-react'
import { CardContent } from '../../../Shared/Card'

const IconWithContentCardContent = ({ iconElement, contentElement }) => {
    return (
      <CardContent
        css={css`
            display: grid;
            grid-template-columns: auto 1fr;
            align-items: center;
        `}
      >
          <IconGroup
            size="big"
            css={css`
                margin: 1.2rem 1.8rem;
            `}
          >
                {iconElement}
          </IconGroup>

          {contentElement}
      </CardContent>
    )
}

export { IconWithContentCardContent }
